import { EvalCheck, SubRating } from "@/lib/types";

// Star weight per sub-rating; the pass bar across the journey tools is
// "Strong or better" (4+).
const ratingStars: Record<SubRating, number> = {
  Excellent: 5,
  Strong: 4,
  Developing: 3,
  Emerging: 2,
  "Needs work": 1,
};

const PASS_STARS = 4;

// Adaptive feedback density: decide, per check, whether to show its full body
// (a paragraph) or collapse it to a label+rating chip.
//
// The rule: a body earns its space only when it carries signal the learner must
// act on — i.e. the axis fell below the pass bar (a correction). Clean axes
// collapse to chips, which still teach the rubric by name without the wall of
// prose. When every axis is clean, we keep exactly one body — the last check,
// by convention the decisive / summary axis — so a pass still says one useful
// thing instead of nothing.
//
// Returns a boolean per check (true = expand to full body), preserving order.
export function selectExpandedChecks(checks: EvalCheck[]): boolean[] {
  if (checks.length === 0) return [];
  if (checks.length === 1) return [true];

  const belowBar = checks.map((c) => ratingStars[c.rating] < PASS_STARS);
  if (belowBar.some(Boolean)) return belowBar;

  // All clean: expand only the last (decisive) axis.
  return checks.map((_, i) => i === checks.length - 1);
}
